// Config
import { NAVIGATE } from '@constants/actionConstants';
import { navigate } from '@utils/navigation/navigationService';

export const navigationMiddleware = () => (next) => (action) => {
  const actionType = action.type || '';

  if (actionType === NAVIGATE) {
    const { to, options } = action.payload;

    if (typeof to === 'number') {
      navigate(to);
    } else {
      navigate(to, options);
    }
  }
  return next(action);
};
